const cards = [
  {
    id: 1,
    title: '谍影重重：暗夜行动',
    tag: '动作悬疑',
    desc: '前特工再度出山，一场跨越三大洲的惊险追逐，高能反转不断。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20noir%20style%20scene%20with%20a%20man%20in%20dark%20coat%20walking%20through%20rainy%20European%20street%20at%20night%2C%20warm%20streetlamp%20glow%2C%20mysterious%20atmosphere%2C%20reflective%20wet%20cobblestone%2C%20dramatic%20shadows%2C%20movie%20poster%20composition%2C%20sophisticated%20thriller%20aesthetic&width=800&height=500&seq=card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '唐朝诡事录',
    tag: '古装奇幻',
    desc: '大唐盛世下的隐秘奇案，诡异事件背后暗藏惊天阴谋。',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20courtyard%20at%20twilight%20with%20red%20lanterns%20and%20mysterious%20fog%2C%20traditional%20architecture%20with%20intricate%20wooden%20details%2C%20dramatic%20warm%20golden%20and%20deep%20red%20lighting%2C%20suspenseful%20period%20drama%20aesthetic%2C%20cinematic%20composition%2C%20rich%20atmospheric%20mood&width=800&height=500&seq=card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '极地生存指南',
    tag: '冒险纪录',
    desc: '零下50度的真实冒险，人类在极端环境下的生存奇迹实录。',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20arctic%20landscape%20with%20vast%20snow-covered%20mountains%20under%20crystal%20clear%20blue%20sky%2C%20soft%20winter%20sunlight%2C%20pristine%20white%20snow%20textures%2C%20documentary%20style%20cinematography%2C%20clean%20minimal%20composition%2C%20crisp%20icy%20blue%20and%20white%20color%20palette%2C%20epic%20widescreen%20aesthetic&width=800&height=500&seq=card-03&orientation=landscape',
  },
  {
    id: 4,
    title: '恋爱推理社',
    tag: '都市甜宠',
    desc: '当理性分析遇上感性心动，一场关于爱的逻辑博弈。',
    img: 'https://readdy.ai/api/search-image?query=Cozy%20modern%20cafe%20interior%20with%20warm%20ambient%20lighting%2C%20two%20people%20sitting%20across%20a%20wooden%20table%20in%20soft%20focus%2C%20romantic%20urban%20atmosphere%2C%20books%20and%20coffee%20details%2C%20natural%20window%20light%2C%20contemporary%20romance%20film%20aesthetic%2C%20gentle%20warm%20tones%2C%20intimate%20composition&width=800&height=500&seq=card-04&orientation=landscape',
  },
  {
    id: 5,
    title: '武当问道',
    tag: '文化纪录',
    desc: '深入武当山，探寻千年道家文化与武术传承的真实面貌。',
    img: 'https://readdy.ai/api/search-image?query=Misty%20Chinese%20mountain%20temple%20complex%20at%20sunrise%2C%20ancient%20taoist%20architecture%20perched%20on%20cliff%20edge%2C%20golden%20morning%20light%20through%20pine%20trees%2C%20ethereal%20clouds%20below%20peaks%2C%20serene%20spiritual%20atmosphere%2C%20documentary%20cinematography%2C%20rich%20green%20and%20warm%20amber%20tones&width=800&height=500&seq=card-05&orientation=landscape',
  },
  {
    id: 6,
    title: 'AI纪元',
    tag: '科幻剧集',
    desc: '不远的未来，人工智能觉醒后的世界秩序将如何被重塑？',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20smart%20city%20skyline%20at%20night%20with%20holographic%20displays%20and%20neon%20accents%2C%20sleek%20glass%20architecture%2C%20clean%20minimalist%20sci-fi%20aesthetic%2C%20soft%20blue%20and%20teal%20ambient%20lighting%2C%20professional%20cinematic%20composition%2C%20atmospheric%20fog%2C%20high-tech%20urban%20environment&width=800&height=500&seq=card-06&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-3 whitespace-nowrap">
            新片速递
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            新片推荐
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            最新上架的高质量影视内容，涵盖动作、古装、科幻等多种类型
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card) => (
            <a
              key={card.id}
              href="#media"
              className="group block bg-background-50 rounded-xl border border-background-200/60 overflow-hidden transition-all hover:-translate-y-1 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  <span className="px-2 py-0.5 text-[10px] font-medium rounded bg-primary-100 text-primary-700 whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
                <h3 className="text-base md:text-lg font-bold text-foreground-900 group-hover:text-primary-600 transition-colors mb-2">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">{card.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}